import { MARQUEE } from "@/lib/site";

export default function Marquee() {
  const items = [...MARQUEE, ...MARQUEE];
  return (
    <div className="w-full overflow-hidden border-y border-line bg-paper py-6" data-testid="marquee">
      <div className="flex w-max animate-marquee">
        {items.map((item, i) => (
          <div key={i} className="flex items-center">
            <span className="whitespace-nowrap font-mono text-sm uppercase tracking-[0.25em] text-ink px-16">
              {item}
            </span>
            <span className="h-1.5 w-1.5 rounded-full bg-clay" />
          </div>
        ))}
      </div>
    </div>
  );
}
